import { gql } from 'apollo-angular'

export const CANCEL_SUBSCRIPTION = gql`
  mutation CancelSubscription($id: Int!, $endDate: String!) {
    updateSubscription(id: $id, data: { endDate: $endDate }) {
      id
    }
  }
`
